export default {
  presetSelectPlaceholder: 'Vybrať predvoľbu',
  modalTitle: 'Predvoľby vzorky',
  currentSelection: 'Aktuálny výber',
};
